import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ProductService } from '@core/interfaces';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { addMonths, format, isSameMonth, startOfMonth } from 'date-fns';
import { first } from 'lodash';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

export interface YearMonth {
  name: string;
  value: string;
}

@Component({
  selector: 'fc-year-month-input',
  templateUrl: './fc-year-month-input.component.html',
  styleUrls: ['./fc-year-month-input.component.scss']
})
export class FcYearMonthInputComponent implements OnInit {
  @Input()
  public control: FormControl;

  @Input()
  public showSearchIcon = false;

  @Input()
  public requiredMark = false;

  @Input()
  public label = null;

  @Input()
  public translateErrorPrefix: string;

  @Input()
  private minDate: Date;

  @Input()
  private maxDate: Date;

  public values: YearMonth[] = [];

  constructor(
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService,
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.search = this.search.bind(this);
    this.displayWith = this.displayWith.bind(this);
  }

  public ngOnInit(): void {
    this.minDate = startOfMonth(this.minDate);
    this.maxDate = startOfMonth(this.maxDate);

    let current = this.minDate;
    while (true) {

      this.values.push({
        name: current.toLocaleString('default', { month: 'long', year: 'numeric' }).replace(/^\w/, (c) => c.toUpperCase()),
        value: format(current, 'yyyy-MM')
      });


      if (isSameMonth(current, this.maxDate)) { break; }

      current = addMonths(current, 1);
    }

    this.values = this.values.reverse();

    const firstValue = first(this.values);
    if (firstValue && !this.control.value) {
      this.control.setValue(firstValue);
    }
  }

  async search(searchTerm: string): Promise<YearMonth[]> {
    searchTerm = (searchTerm.toLowerCase() || '').trim();

    return this.values.filter((item: YearMonth) => {
      return item.name.toLowerCase().includes(searchTerm) || item.value.toLowerCase().includes(searchTerm);
    });
  }

  displayWith(value: ProductService): string {
    return value && value.name;
  }
}
